import { render, staticRenderFns } from "./ContentComponent.vue?vue&type=template&id=1f4f889c&scoped=true&"
import script from "./ContentComponent.vue?vue&type=script&lang=ts&"
export * from "./ContentComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4f889c",
  null
  
)

export default component.exports